import { Directive, Input, OnDestroy, TemplateRef, ViewContainerRef } from '@angular/core';
import { UserRoleType } from '@vi-iot/client';
import { AuthStore } from '@store';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Directive({
  selector: '[appHideForUserRole]',
})
export class HideForUserRoleDirective implements OnDestroy {
  private ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(
    private viewContainer: ViewContainerRef,
    private templateRef: TemplateRef<any>,
    private authStore: AuthStore
  ) {}

  @Input('appHideForUserRole') set hideForUserRole(role: UserRoleType) {
    this.authStore
      .getUserIotRole()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((userRole) => {
        if (userRole === role) {
          this.viewContainer.clear();
        } else {
          this.viewContainer.createEmbeddedView(this.templateRef);
        }
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
